export type KostnadsKalkyleTab =
    | 'kostnadskalkyle'
    | 'lønnsomhet'
    | 'kostnadstyper';

// BPMN-nøkler (uten ø) → interne fane-verdier. Kostnadskalkyle er startfanen og kan ikke deaktiveres.
const BPMN_TAB_KEYS = new Map<string, KostnadsKalkyleTab>([
    ['lonnsomhet', 'lønnsomhet'],
    ['kostnadstyper', 'kostnadstyper'],
]);

/** Leser BPMN-propertyen `disabledTabs` (kommaseparert). Ukjente nøkler ignoreres. */
export const parseDisabledTabs = (
    value?: string,
): ReadonlySet<KostnadsKalkyleTab> =>
    new Set(
        (value ?? '')
            .split(',')
            .map((key) => BPMN_TAB_KEYS.get(key.trim().toLowerCase()))
            .filter((tab): tab is KostnadsKalkyleTab => tab !== undefined),
    );
